import { render, staticRenderFns } from "./PurchasePromotions.vue?vue&type=template&id=ebb045ec&"
import script from "./PurchasePromotions.vue?vue&type=script&lang=js&"
export * from "./PurchasePromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports